import { MANIFEST_ICONS, SwanIconKey } from '@vp/swan';

export default function isSwanIconKey(value: string | null): value is SwanIconKey {
    return value !== null && value in MANIFEST_ICONS;
}
